/**
 * Created by one on 2016/10/27.
 */
export default {
  state: {
    currNavBar:"commonFunc",
    navBar:{
      //1:{
      //  id:"addTextLink",
      //  name:"文本链接",
      //  icon:"tab-icon-img",
      //  link:""
      //},
      2:{
        id:"commonFunc",
        name:"常用功能",
        icon:"tab-icon-img",
        link:""
      },
/*      3:{
        id:"addSuit",
        name:"添加搭配",
        icon:"tab-icon-img",
        link:""
      },*/
      4:{
        id:"tuku",
        name:"我的图库",
        icon:"tab-icon-img",
        link:""
      },
      5:{
        id:"gallery",
        name:"素材库",
        icon:"tab-icon-img",
        link:""
      }
    },
    editContent:{
    },
    currGoodsObj:{
      goodsId:"",
      name:"",
      image:{      //可以为空
        image:"",//https://yd-inner-image.b0.upaiyun.com/Files/58/45/58454a70356ca9ce23053aa18b09d41baea52b9a_117563.jpg?imageMogr/v2/auto-orient/thumbnail/!290x/quality/80/
        width:0,
        height:0
      },
      modeType:1,  //1:大卡片 2：小卡片
      type:5,
      indexNum:0
    },
    currImgObj:{
      // image:{},
      // type:1,
      // indexNum:-1,
      // proportion:100 //占比，%比
    },
    currEditObj:{
    },
    currOtherTypeImg:{},
    maxIndex:0,
    isShowGoodsEdit:false,
    isShowSuitEdit:false,
    isShowProportion:false,
    isShowTextLinkEdit:false,
    isShowLinkEdit:false,
    isShowEditTextLinkEdit:false,//编辑器自定义链接
    isShowVideoEdit:false,
    // 是否滚动，用于watch使用
    isScroll:false,
    currentSelectedIndex:-1
  },

  mutations: {
    SET_EDIT_CONTENT_OBJECT(state,obj,objKey) {
      let _editContent = _.toArray(_.clone(state.editContent));
      let _indexNum = _.findIndex(_editContent,{indexNum:objKey});
      if(_indexNum == -1) {
        state.maxIndex ++;
          // 如果是在指定位置插入，那么不要滚动
        if (state.currentSelectedIndex >= 0) {
          _editContent.splice(state.currentSelectedIndex + 1, 0, obj);
          state.currentSelectedIndex = state.currentSelectedIndex + 1;
        } else {
          _editContent.push(obj);
          state.isScroll = !state.isScroll;
        }
      } else {
        _editContent[_indexNum] = obj;
      }
      state.editContent = _editContent;
    },
    DEL_EDIT_CONTENT_OBJECT(state,objKey) {
      let _editContent = _.toArray(_.clone(state.editContent));
      let _indexNum = _.findIndex(_editContent,{indexNum:objKey});
      _editContent.splice(_indexNum,1);
      state.editContent = _editContent;
    },
    SET_ALL_EDIT_CONTENT_OBJECT(state,allEditContent) {
      state.editContent = allEditContent;
    },
    GET_EDIT_CONTENT(state) {
      return state.editContent;
    },
    GET_EDIT_CONTENT_BY_OBJKEY(state,objKey) {
      if(state.editContent[objKey]) {
        return state.editContent[objKey]
      }
      return false;
    },
    ///////letBar////////
    SET_CURR_NAV_BAR(state,barId) {
      state.currNavBar = barId;
    },
    //////goods/////////
    SET_IS_SHOW_GOODS_EDIT(state,isShow) {
      state.isShowGoodsEdit = isShow;
    },
    SET_CURR_GOODS_OBJ(state,goodsObj) {
      state.currGoodsObj = goodsObj;
    },
    ////////Suit///////////
    SET_IS_SHOW_SUIT_EDIT(state,isShow) {
      state.isShowSuitEdit = isShow;
    },
    ////////Img///////////
    SET_CURR_IMG(state,imgObj) {
      state.currImgObj = imgObj;
    },
    ////////ImgLink//////
    SET_IS_SHOW_IMG_LINK_EDIT(state,isShow) {
      state.isShowImgLinkEdit = isShow;
    },
    ////////TextLink//////
    SET_IS_SHOW_TEXT_LINK_EDIT(state,isShow) {
      state.isShowTextLinkEdit = isShow;
    },
    SET_IS_SHOW_LINK_EDIT(state,isShow) {
      state.isShowLinkEdit = isShow;
    },
    //SET_CURR_TEXT_LINK(state,textLink) {
    //  state.currTextLinkObj = textLink;
    //},
    SET_CURR_EDIT_OBJ(state,obj) {
      state.currEditObj = obj;
    },
    ////////Video//////
    SET_IS_SHOW_VIDEO_EDIT(state,isShow) {
      state.isShowVideoEdit = isShow;
    },
    SET_CURR_VIDEO_OBJ(state,isShow) {
      state.isShowVideoEdit = isShow;
    },
    ////////IsShowProportion////////
    SET_IS_SHOW_PROPORTION(state,isShow) {
      state.isShowProportion = isShow;
    },
    SET_CURRENT_SELECTED_INDEX(state,indexNum) {
      state.currentSelectedIndex=indexNum;
      state.currImgObj = {};
    },
    ////////IsShowEditLinkEdit/////////
    SET_IS_SHOW_EDIT_TEXT_LINK_EDIT(state,isShow) {
      state.isShowEditTextLinkEdit=isShow;
    }
  }
}
